module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ad218339ca42519f314d17dba03dff83.png";